import { useLang } from "@/context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  return (
    <div
      className="relative overflow-hidden border-y border-white/10 bg-navy/40 py-5"
      data-testid="marquee"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center" aria-hidden={dup === 1}>
            {t.marquee.map((item, i) => (
              <span
                key={`${dup}-${i}`}
                className="flex items-center gap-6 whitespace-nowrap px-6 font-display text-lg uppercase tracking-wide text-slate-300 sm:text-xl"
              >
                {item}
                <i className="fa-solid fa-plus text-xs text-crimson" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
